import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (!environment.production && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', {
        updateViaCache: 'none',
      })
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          registration.installing?.postMessage({ type: 'SKIP_WAITING' });
        });

        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });

        document.addEventListener('visibilitychange', () => {
          registration.active?.postMessage({
            type: 'VISIBILITY_CHANGE',
            visible: document.visibilityState === 'visible',
          });
        });
      })
      .catch((error) => {
        console.error('[App] Error registering SW:', error);
      });
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
